<template>
  <div class="MorakhasiDetails">
    <v-row>
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblhozormorakhasiRozane")
        }}:<span class="text-value px-1">{{
          ConvertMinuteToHour(details.PRESENCEINDMOR)
        }}</span></v-col
      >
      <v-col cols="12" sm="6"></v-col>
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblMorakhasiBaHoghogh")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.LEAVEOFABSPAY)
        }}</span></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblMorakhasiBedoneHoghogh")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.LEAVEOFABSNOPAY)
        }}</span></v-col
      >
      <v-col cols="12" sm="6"
        >{{ $t("PeriodWorkDetails.MorakhasiDetails.lblSahmieMorakhasi") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.MORKHASIRATION) }}</span
        ></v-col
      >
      <v-col cols="12" sm="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblMorakhasiEstehghaghi")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.ORDMOR)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblMandeMorakhasiTaKnon")
        }}:<span class="text-value">{{
          vacationRemain.MandeTakonon
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.MorakhasiDetails.lblMandeMorakhasiAzSaleGhabl")
        }}:<span class="text-value">{{
          vacationRemain.MandeAzSaleGhabl
        }}</span></v-col
      >
      <v-col cols="12">
        <box class="mt-2" title="<small>ریز مرخصی</small>">
          <div class="">
            <v-data-table
              dense
              :headers="periodVacationDetailsHeader"
              :items="periodVacationDetails"
            ></v-data-table>
          </div>
        </box>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    details: Object,
  },
  data() {
    return {
      vacationRemain: {},
      periodVacationDetails: [],
      periodVacationDetailsHeader: [
        {
          text: this.$t("vacationType"),
          value: "NAME",
        },
        {
          text: this.$t("vacationAmount"),
          value: "mizan",
        },
      ],
    };
  },
  watch: {
    details(newVal) {
      if (newVal.PERIOD) {
        this.GetVacationRemainDetail();
        this.GetPeriodVacationDetail();
      }
    },
  },
  mounted() {
    console.log(this.details);
    if (this.details.PERIOD) {
      this.GetVacationRemainDetail();
      this.GetPeriodVacationDetail();
    }
  },
  methods: {
    GetVacationRemainDetail() {
      const params = new URLSearchParams();
      params.append("period", this.details.PERIOD);
      params.append("year", this.details.year);
      if (this.details.PERNO) {
        params.append("perno", this.details.PERNO);
      }

      this.$store
        .dispatch("GetVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.vacationRemain = result.data;
          }
        });
    },
    GetPeriodVacationDetail() {
      const GetPeriodVacationDetailParams = {
        period: this.details.PERIOD,
        year: this.details.year,
        isPeriod: this.details.isPeriod,
      };

      if (this.details.PERNO) {
        GetPeriodVacationDetailParams.perno = this.details.PERNO;
      }

      this.$store
        .dispatch("GetPeriodVacationDetail", { GetPeriodVacationDetailParams })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.periodVacationDetails = result.data.Table;
          }
        });
    },
  },
};
</script>

<style scoped>
.MorakhasiDetails .row .col {
  padding: 2px !important;
}
</style>